import type { Member, MemberSeat, MemberStatus, Organization } from './types'
import { getBranchColor } from '../../../BranchSwitcher/colors'

export const ROLE_OPTIONS = ['Loan Officer', 'Owner', 'Processor'] as const
export const HARD_MONEY_ROLE_OPTIONS = ['Underwriter', 'Closer'] as const
export const STATUS_FILTER_OPTIONS: MemberStatus[] = ['Active', 'Invited', 'Disabled']
export const SEAT_FILTER_OPTIONS: MemberSeat[] = ['Paid', 'Free']
export const TABLE_COLUMNS = ['Email', 'Full name', 'Role in this org', 'NMLS', 'Organizations', 'Status', 'Seat', 'Actions'] as const

export const INITIAL_ORGS: Organization[] = [
  {
    id: 'pa',
    customerId: 'pa',
    name: 'GMCC — Palo Alto',
    short: 'PA',
    color: getBranchColor(0),
    address: '328 University Ave, Palo Alto, CA 94301',
    plan: 'Business',
    myRole: 'Admin',
    roles: ['Owner'],
    canManageUsers: true,
    canCreateOrganization: false,
  },
  {
    id: 'sj',
    customerId: 'sj',
    name: 'GMCC — San Jose',
    short: 'SJ',
    color: getBranchColor(1),
    address: '1 W Santa Clara St, San Jose, CA 95113',
    plan: 'Enterprise',
    myRole: 'Admin',
    roles: ['Owner'],
    canManageUsers: true,
    canCreateOrganization: false,
  },
  {
    id: 'cf',
    customerId: 'cf',
    name: 'Coastal Funding Group',
    short: 'CF',
    color: getBranchColor(2),
    address: '660 Ocean Ave, Santa Cruz, CA 95060',
    plan: 'Business',
    myRole: 'Loan Officer',
    roles: ['LoanOfficer'],
    canManageUsers: false,
    canCreateOrganization: false,
  },
]

export const INITIAL_MEMBERS: Member[] = [
  { id: 'ya.luo', email: 'ya.luo@zeitro.com', firstName: 'Ya', lastName: 'Luo', name: 'Ya Luo', nmls: '555670', status: 'Active', roles: { pa: 'Loan Officer', sj: 'Loan Officer' } },
  { id: 's.park', email: 's.park@gmccloan.com', firstName: 'Susan', lastName: 'Park', name: 'Susan Park', nmls: '—', status: 'Active', roles: { pa: 'Admin', sj: 'Admin' } },
  { id: 'm.chen', email: 'm.chen@gmccloan.com', firstName: 'Michael', lastName: 'Chen', name: 'Michael Chen', nmls: '2510578', status: 'Active', roles: { pa: 'Loan Officer' } },
  { id: 'd.wu', email: 'd.wu@gmccloan.com', firstName: 'David', lastName: 'Wu', name: 'David Wu', nmls: '123333', status: 'Invited', roles: { pa: 'Loan Officer' } },
  { id: 'k.nguyen', email: 'k.nguyen@gmccloan.com', firstName: 'Kim', lastName: 'Nguyen', name: 'Kim Nguyen', nmls: '2231144', status: 'Active', roles: { sj: 'Loan Officer' } },
  { id: 'j.rivera', email: 'j.rivera@gmccloan.com', firstName: 'Jorge', lastName: 'Rivera', name: 'Jorge Rivera', nmls: '—', status: 'Invited', roles: { sj: 'Processor' } },
]
